<template>
    <ElDialog
        class="modal" 
        :visible.sync="showModal" 
        :width="modalWidth">
        <h2 class="modal__title">
            {{ title }}
        </h2>
        <div class="modal__body">
            <p class="modal__text">
                {{ text }}
            </p>
        </div>
        <div class="modal__submit-buttons">
            <BaseButton text="Закрыть окно" 
                size="large" 
                @click.native="closeModal" />
        </div>
    </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
    name: 'ModalPolicyIssuanceError',
    components: {
        BaseButton
    },
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },
    mixins: [modal]
}
</script>